import { useMutation } from '@tanstack/react-query'

import { AxiosError } from 'axios'
import { ErrorHandling } from '../../@types/ErrorHandling'
import { ValidateEntityClientRequest } from '../../@types/PolicyHolderDetails'
import { api } from '../../Services/API'
import { API_ROUTES } from '../../constants/apiRoutes'
import { useErrorRequest } from '../useErrorRequest'

const request = async (payload: ValidateEntityClientRequest) => {
  const { data } = await api.post(API_ROUTES.validateEntity, payload)

  return data
}

export const useValidateNif = () => {
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: ValidateEntityClientRequest) => request(payload),
    onError: (error: AxiosError<ErrorHandling[]>) => {
      handleErrorRequest({ error })
    },
  })
}
